export const EventManagementTabs = {
  SUMMARY: 'summary',
  DETAILS: 'details',
  CHARITY: 'charity',
  GUEST_ORDERS: 'guest-orders',
};
